import {
    setDoNotShowDl,
    funnelUpdate,
    updateUserPrefs,
    isPageReloadedAfterLogin,
} from './module_common';

window.setDoNotShowDl = setDoNotShowDl

// used to avoid sending funnel_events twice
window.isPageReloadedAfterLogin = isPageReloadedAfterLogin()

// for post-login sequence and actions
window.funnelUpdate = funnelUpdate
window.updateUserPrefs = updateUserPrefs